import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// components
import Anchor from 'Components/common/Anchor';
import Header from 'Components/common/Header';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import ProductImage from 'Components/commonOrder/ProductImage';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import MyOrderItem from './MyOrderItem';
import Dropdown from 'Components/common/Dropdown';

import {getOrderDetails, notShipOrder} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import {setUserData, setSCData} from 'Actions/localData';
import {
    updateMyOrderSearchFields,
    updateMyOrderSearchList,
    updateOrderSearchIsLastPage,
    getCustomerAccount,
    updateMyOrderList,
    updateSearchTypeObj,
    getMyOrderList,
    receiveShipment,
    repeatOrder,
    getShipments,
    setCurrentOrderId,
    setSalesOrderOnholdStatus,
    updateSalesOrderListPageNum,
    setFromMyOrderDetails,
} from 'Actions/myOrder';
import {T} from 'Actions/translate';
// Icons
import {ArrowForwardIosOutlined} from '@material-ui/icons';
import {PURCHASE_ORDER_MODE, MY_ORDER_STATUS} from 'Utils/constant';

class MyOrderList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    constructor(props) {
        super(props);
        this.state = {
            tabList: [
                {
                    index: 0,
                    text: T('user_center_not_receive'),
                    tabFlag: 1,
                    name: 'noReceive',
                },
                {
                    index: 1,
                    text: T('user_center_received'),
                    tabFlag: 2,
                    name: 'received',
                },
                {
                    index: 2,
                    text: T('user_center_canceled'),
                    tabFlag: 3,
                    name: 'canceled',
                },
            ],
            searchList: [
                {
                    id: 1,
                    fullName: T('shipment_all_order'),
                    searchKey: null,
                },
                {
                    id: 2,
                    fullName: T('shipment_sales'),
                    searchKey: 'sales',
                },
                {
                    id: 3,
                    fullName: T('shipment_customer'),
                    searchKey: 'customer',
                },
            ],
            searchId: '全部',
            searchValue: null,
            tabActive: 0,
            listLoaded: true,
            seletedItem: null,
            receiveShipment: null,
            receiveDialogOpened: false,
            showSearchContainerFlag: false,
            notShipDialogOpened: false,
            chooseCurrentOrderItem: null,
        };

        if (this.props.fromMyOrderDetails) {
            this.props.setFromMyOrderDetails({$set: false});
            this.refreshOnholdOrder();
        } else {
            this.fetchData(); // 在构造函数中调用异步方法
        }
    }

    async fetchData() {
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;

        this.props.updateMyOrderSearchFields({
            orderE1Number: {$set: ''}, //订单号和E1号
            sku: {$set: ''}, //SKU
            scIds: {$set: []}, //现货中心
            scIdsValue: {$set: []},
            institution: {$set: ''}, //课题组
            receiver: {$set: ''}, //收货人
            purchaseNo: {$set: ''}, //采购单
            shipTo: {$set: ''}, //ST#
            webAccount: {$set: ''}, //用户账号
            status: {$set: []}, // 订单状态
            statusValue: {$set: []},
            webOrderType: {$set: []}, //订单类型
            beginTime: {$set: ''}, //购买时间
            endTime: {$set: ''},
            onHold: {$set: ''}, // 暂不发货
            onHoldValue: {$set: false},
        });

        this.props.updateMyOrderSearchList([]);
        await this.props.updateOrderSearchIsLastPage(false);

        switch (this.props.match.path) {
            case '/myOrderList/unreceived':
                this.setState({tabActive: 0}, () => this.getList());
                break;
            case '/myOrderList/received':
                this.setState({tabActive: 1}, () => this.getList());
                break;
            case '/myOrderList/canceled':
                this.setState({tabActive: 2}, () => this.getList());
                break;
            default:
                this.setState({tabActive: 0}, () => this.getList());
        }
    }

    refreshOnholdOrder = () => {
        let {currentOrderId, salesOnholdStatusFlag} = this.props;
        if (salesOnholdStatusFlag) {
            let {tabList, tabActive} = this.state;

            let currentMyOrderList = JSON.parse(
                JSON.stringify(this.props.myOrderList[tabList[tabActive].name]),
            );

            currentMyOrderList.length > 0 &&
                currentMyOrderList.forEach((myOrderItem) => {
                    if (currentOrderId === myOrderItem.id) {
                        myOrderItem.status = MY_ORDER_STATUS.ONHOLD;
                    }
                });

            this.props.updateMyOrderList({
                currentOrderList: currentMyOrderList,
                tab: tabList[tabActive].name,
            });

            this.props.setSalesOrderOnholdStatus({$set: false});
            this.pager.page = this.props.currentPageNum;
            this.props.setCurrentOrderId({$set: ''});
        }
    };

    /**
     * Handle change tab
     * @item { Object } This is a tab item.
     */
    handleChangeTab = (item) => {
        this.props.updateOrderSearchIsLastPage(false);
        switch (item.index) {
            case 0:
                this.props.history.replace('/myOrderList/unreceived');
                break;
            case 1:
                this.props.history.replace('/myOrderList/received');
                break;
            case 2:
                this.props.history.replace('/myOrderList/canceled');
                break;
            default:
                this.props.history.replace('/myOrderList/unreceived');
        }
    };

    goBack = () => {
        this.props.updateSearchTypeObj({
            searchId: '全部',
            searchValue: null,
        });
        this.props.history.push('/userCenter');
    };

    goToMyOrderSearchPage = () => this.props.history.push(`/myOrderSearch`);

    getList = () => {
        // if(this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        this.props
            .getMyOrderList({
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                // email: localData.customerEmail,
                tabFlag: this.state.tabList[this.state.tabActive].tabFlag,
                searchType: this.props.searchTypeObj.searchValue,
            })
            .then((res) => {
                if (!res) return;
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
            })
            .then(() => {
                this.setState({listLoaded: true});
            });
    };

    chooseItem = (item) => {
        const {localData} = this.props;
        this.props.updateSalesOrderListPageNum({$set: this.pager.page});
        if (localData.roleType === 3) {
            this.props.history.push(`/myOrderDetail/${item.id}`, {
                status: item.status,
                orderLockType: util.getLockedType(item),
            });
        } else {
            this.props.history.push(`/myOrderDetail/${item.id}`);
        }
    };

    receiveShipment = (item) => {
        const {receiveShipment} = this.state;

        this.props
            .receiveShipment({shipmentId: receiveShipment.id})
            .then(() => {
                this.setState({receiveDialogOpened: false, selectedItem: null});

                this.props.openNotification(
                    T('notification_successful_receipt_of_goods'),
                    'success',
                );
                this.pager.page = 0;
                this.pager.total = 0;
                this.pager.pageTotal = 9999999999999999999999999;
                this.getList();
            });
    };

    buyAgain = (item) => {
        const {localData} = this.props;
        this.props
            .repeatOrder({
                id: item.id,
                shipToNum: item.shipToNum,
            })
            .then((res) => {
                if (localData.roleType !== 0) {
                    this.props.setUserData({
                        data: {
                            email: item.email,
                            shipToNum: item.shipToNum,
                            isProxyProcess: true,
                            type: localData.roleType,
                            name: localData.name,
                        },
                    });

                    if (
                        res &&
                        res.data &&
                        res.data.shipToSupplyCenter &&
                        res.data.shipToSupplyCenter.supplyCenterId
                    ) {
                        this.props.setSCData({
                            id: res.data.shipToSupplyCenter.supplyCenterId,
                            name: res.data.shipToSupplyCenter.supplyCenterName,
                        });
                    } else {
                        this.props.setSCData({
                            id: -1,
                            name: '',
                        });
                    }
                }

                this.reOrderSendData(
                    item.id,
                    res.data.shipToSupplyCenter,
                    item,
                );
            });
    };

    reOrderSendData = (orderId, supplyCenter, item) => {
        this.props.getOrderDetails({id: orderId}).then((res) => {
            if (res && res.status === 'success') {
                let orderProducts = res.data.orderProducts;
                if (orderProducts.length > 0) {
                    let tempCustomerName = undefined;
                    if (
                        this.getOrderChannel(item.number) ===
                        PURCHASE_ORDER_MODE.ONLINE
                    ) {
                        this.props
                            .getCustomerAccount({
                                email: item.email,
                                shipToNum: item.shipToNum,
                            })
                            .then((customerAccountRes) => {
                                if (
                                    customerAccountRes &&
                                    customerAccountRes.status === 'success' &&
                                    customerAccountRes.data
                                ) {
                                    tempCustomerName =
                                        customerAccountRes.data.lastName +
                                        customerAccountRes.data.firstName;
                                    this.reOrderGogoShoppingCart(
                                        item,
                                        tempCustomerName,
                                        supplyCenter,
                                        res,
                                    );
                                }
                            });
                    } else {
                        this.reOrderGogoShoppingCart(
                            item,
                            tempCustomerName,
                            supplyCenter,
                            res,
                        );
                    }
                }
            }
        });
    };

    reOrderGogoShoppingCart = (item, tempCustomerName, supplyCenter, res) => {
        localStorage.setItem(
            'ltoPurchaseOrderMode',
            this.getOrderChannel(item.number),
        );
        localStorage.setItem('purchaseCustomerEmail', item.email);
        localStorage.setItem('purchaseCustomerName', tempCustomerName);
        if (supplyCenter) {
            this.props.history.push('/purchase/shoppingCart', {
                customerEmail: item.email,
                customerName: tempCustomerName,
                fromReorder: true,
                scName: supplyCenter.supplyCenterName,
            });
        } else {
            this.props.history.push('/purchase/shoppingCart', {
                batchAddShipTo: item.shipToNum,
                batchAddEmail: item.email,
                customerEmail: item.email,
                customerName: tempCustomerName,
            });
        }
    };

    getOrderChannel = (orderNumber) => {
        let purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;
        if (orderNumber.startsWith('P')) {
            purchaseOrderMode = PURCHASE_ORDER_MODE.OFFLINE;
        } else if (orderNumber.startsWith('C')) {
            purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;
        }

        return purchaseOrderMode;
    };

    openReceiveDialog = (item) => {
        this.props.getShipments({id: item.id}).then((res) => {
            let shipments = res.data.shipments || [];
            let receiveShipment = null;

            for (let i = 0; i < shipments.length; i++) {
                if (shipments[i].status === 3) {
                    receiveShipment = shipments[i];
                    break;
                }
            }

            this.setState({
                receiveDialogOpened: true,
                receiveShipment,
                selectedItem: item,
            });
        });
    };

    dialogDidClose = (key) => this.state[key] && this.setState({[key]: false});

    getCurrentTabId = (item) => {
        let currentId = '';
        switch (item.tabFlag) {
            case 1:
                currentId = 'to_be_shipped';
                break;
            case 2:
                currentId = 'to_be_recieved';
                break;
            case 3:
                currentId = 'complete';
                break;
            default:
                break;
        }
        return currentId;
    };

    deliverInforHandle = (item) => {
        this.props.history.push(`/deliverDetails?orderId=${item.id}`);
    };

    gotoLtoHistoryOrderList = (e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }

        this.props.history.push('/purchase/ltoHistoryList');
    };

    initPager = () => {
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
    };

    handleSelectChange = (name, value) => {
        console.log(name, value);
        let tab = '';
        switch (this.state.tabList[this.state.tabActive].tabFlag) {
            case 1:
                tab = 'noReceive';
                break;
            case 2:
                tab = 'received';
                break;
            case 3:
                tab = 'canceled';
                break;
            default:
        }
        this.props.updateMyOrderList({currentOrderList: [], tab: tab});
        this.props.updateSearchTypeObj({
            searchId: value.id,
            searchValue: value.searchKey,
        });
        this.initPager();
        this.setState(
            {
                searchId: value.id,
                searchValue: value.searchKey,
            },
            () => {
                this.getList();
            },
        );
    };

    focusInput = () => {
        const {searchList} = this.state;
        this.setState({
            searchList: searchList,
        });
    };

    getPlaceholderValue = () => {
        const {searchTypeObj} = this.props;
        let tempPlaceholder = 'shipment_all_order';
        if (searchTypeObj.searchId === 1) {
            tempPlaceholder = 'shipment_all_order';
        } else if (searchTypeObj.searchId === 2) {
            tempPlaceholder = 'shipment_sales';
        } else if (searchTypeObj.searchId === 3) {
            tempPlaceholder = 'shipment_customer';
        }

        return tempPlaceholder;
    };

    orderOnHoldHandle = () => {
        const {chooseCurrentOrderItem} = this.state;
        this.props
            .notShipOrder({orderId: chooseCurrentOrderItem.id})
            .then((status) => {
                this.setState({
                    notShipDialogOpened: false,
                    chooseCurrentOrderItem: '',
                });
                this.props.openNotification(
                    T('my_order_on_hold_already_success'),
                    'success',
                    {
                        testid: 'my_order_list_on_hold_success',
                    },
                );
                this.refreshOnholdOrder();
            })
            .catch((res) => {
                if (res && res.message) {
                    if (res.message === 'Black_Sku') {
                        this.setState({
                            notShipDialogOpened: false,
                            chooseCurrentOrderItem: '',
                        });
                        this.props.openNotification(
                            T(
                                'grey_list_products_can_not_be_temporarily_shipped',
                            ),
                            'danger',
                        );
                    }
                }
            });
    };

    openNotShipDialog = (item) => {
        this.props.updateSalesOrderListPageNum({$set: this.pager.page});
        this.props.setSalesOrderOnholdStatus({$set: true});
        this.props.setCurrentOrderId({$set: parseInt(item.id)});
        this.setState({
            chooseCurrentOrderItem: item,
            notShipDialogOpened: true,
        });
    };

    render() {
        let {myOrderList, localData, orderSearchIsLastPage, searchTypeObj} =
            this.props;
        let {
            tabList,
            tabActive,
            selectedItem,
            receiveShipment,
            receiveDialogOpened,
            searchList,
            notShipDialogOpened,
        } = this.state;

        return (
            <div className="my-order-list-container">
                <Header
                    hasArrowBackIos={true}
                    hasShoppingCart={false}
                    hasUserCenter={false}
                    backEvent={this.goBack}>
                    <div className="header-box">
                        <div className="my-order-header-title-contanier">
                            <h3 className="header-title">
                                {localData.roleType === 0
                                    ? T('order_my_order')
                                    : T('order_customer_order')}
                            </h3>
                            <div
                                className="goto-purchase-order-history"
                                onClick={this.gotoLtoHistoryOrderList}>
                                {T('lto_history_list')}
                                <ArrowForwardIosOutlined />
                            </div>
                        </div>
                        <SearchInput
                            placeholder={T('enter_orderNo_sku_subject_eoneNo')}
                            testid="customer-order-search-input"
                            onFocus={this.goToMyOrderSearchPage}
                            options={{hideSearchBtn: true}}
                        />
                    </div>
                    <div className="tab-header">
                        <div className="tab-list">
                            {tabList.map((item, index) => (
                                <Anchor
                                    id={this.getCurrentTabId(item)}
                                    testid={
                                        'order_' + this.getCurrentTabId(item)
                                    }
                                    key={index}
                                    className={util.getClassName({
                                        'tab-item': true,
                                        active: index === tabActive,
                                    })}
                                    onClickOfSingleTap={() => {
                                        this.handleChangeTab(item);
                                    }}>
                                    {item.text}
                                </Anchor>
                            ))}
                            <div className="search-shipment-list">
                                <Dropdown
                                    placeholder={this.getPlaceholderValue()}
                                    list={searchList}
                                    value={searchTypeObj.searchId}
                                    inputValid={this.handleSelectChange}
                                    type="text"
                                    testid="my-order-search-dropdown"
                                    focusInput={() => {
                                        this.focusInput('searchType');
                                    }}
                                    showArrowDropDown={true}
                                />
                            </div>
                        </div>
                    </div>
                </Header>

                <ScrollWrapper
                    listLoaded={this.state.listLoaded}
                    showAbyss={orderSearchIsLastPage}
                    showLoadingMore={!this.state.listLoaded}
                    getMoreData={this.getList}>
                    <ul className="my-order-list">
                        {myOrderList[tabList[tabActive].name] &&
                            myOrderList[tabList[tabActive].name].map(
                                (item, index) => {
                                    let isShipped = false;
                                    item.orderProducts &&
                                        item.orderProducts.forEach(
                                            (product) => {
                                                if (product.shippedQuantity > 0)
                                                    isShipped = true;
                                            },
                                        );

                                    return (
                                        <MyOrderItem
                                            key={index}
                                            item={item}
                                            chooseItem={this.chooseItem}
                                            options={{
                                                showTag: tabActive === 0,
                                                showReceiveBtn:
                                                    item.orderType === 'SCM' &&
                                                    (item.status === 3 ||
                                                        item.status === 2 ||
                                                        item.status === 1) &&
                                                    localData.roleType === 0 &&
                                                    isShipped,
                                                receiveOrder: () =>
                                                    this.openReceiveDialog(
                                                        item,
                                                    ),
                                                buyAgain: () =>
                                                    this.buyAgain(item),
                                                deliverInfor: () =>
                                                    this.deliverInforHandle(
                                                        item,
                                                    ),
                                                orderOnHoldInfo: () => {
                                                    this.openNotShipDialog(
                                                        item,
                                                    );
                                                },
                                            }}></MyOrderItem>
                                    );
                                },
                            )}
                    </ul>
                </ScrollWrapper>
                <Dialog
                    opened={receiveDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('receiveDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="receive-order-confirm-dialog">
                        <h5>
                            {selectedItem && selectedItem.partialDelivery
                                ? T('order_partial_receipt_confirm')
                                : T('order_full_receipt_confirm')}
                        </h5>
                        <ul className="product-list">
                            {receiveShipment &&
                                receiveShipment.shipmentProducts &&
                                receiveShipment.shipmentProducts.map((item) =>
                                    item.shippedQuantity > 0 ? (
                                        <li>
                                            <p
                                                className="product-name"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item.product &&
                                                        item.product
                                                            .productName,
                                                }}
                                            />
                                            <div className="details">
                                                <div className="image-box">
                                                    <ProductImage
                                                        src={
                                                            item.product &&
                                                            item.product
                                                                .productPic
                                                        }
                                                        alt={
                                                            item.product &&
                                                            item.product
                                                                .productName
                                                        }
                                                        key={
                                                            item.product &&
                                                            item.product
                                                                .productPic
                                                        }
                                                    />
                                                </div>
                                                <div className="details-text">
                                                    <p className="text-ellipsis">
                                                        {T(
                                                            'product_specifications_colon',
                                                        )}
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    item.product &&
                                                                    item.product
                                                                        .specifications,
                                                            }}
                                                        />
                                                    </p>
                                                    <p className="text-ellipsis">
                                                        {T(
                                                            'not_shippment_quantity_colon',
                                                        )}{' '}
                                                        {item.tobeshippedQuantity ||
                                                            item.onholdQuantity}
                                                    </p>
                                                    <p className="point text-ellipsis">
                                                        {T(
                                                            'order_current_shippment_number_colon',
                                                        )}{' '}
                                                        {item.quantity}
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    ) : null,
                                )}
                        </ul>
                        <BasicButton
                            type="primary"
                            className="confirm-btn"
                            onClickOfSingleTap={() =>
                                this.receiveShipment(selectedItem)
                            }>
                            {T('order_confirm_receive')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={notShipDialogOpened}
                    testid="my_order_list_onhold_dialog"
                    dialogDidClose={() =>
                        this.dialogDidClose('notShipDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="not-ship-dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_temporary_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_temporary_delivery')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            testid="my_order_list_onhold_dialog_confirm_btn"
                            className="not-ship-confirm-btn"
                            onClickOfSingleTap={this.orderOnHoldHandle}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {myOrder, localData} = state;
    return {
        myOrderList: myOrder.myOrderList,
        localData: localData,
        orderSearchIsLastPage: myOrder.orderSearchIsLastPage,
        customerAccountDetail: myOrder.customerAccountDetail,
        searchTypeObj: myOrder.searchTypeObj,
        salesOnholdStatusFlag: myOrder.salesOnholdStatusFlag,
        currentOrderId: myOrder.currentOrderId,
        currentPageNum: myOrder.currentPageNum,

        fromMyOrderDetails: myOrder.fromMyOrderDetails,
    };
};

const mapDispatchToProps = {
    getMyOrderList,
    receiveShipment,
    openNotification,
    repeatOrder,
    setUserData,
    getShipments,
    setSCData,
    updateMyOrderSearchFields,
    updateMyOrderSearchList,
    getOrderDetails,
    updateOrderSearchIsLastPage,
    getCustomerAccount,
    updateMyOrderList,
    updateSearchTypeObj,
    notShipOrder,

    setSalesOrderOnholdStatus,
    updateSalesOrderListPageNum,
    setCurrentOrderId,
    setFromMyOrderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrderList);
